import React from 'react';
import { FOOTER_LEGAL_LINKS } from '@/lib/legalLinks';

/**
 * The row of legal links (privacy, terms, cookies, PAIA, disclaimer) under
 * every public page. Shared by the landing-page footer and the bio page so
 * neither can drop one. Always rendered: the links don't depend on whether
 * the brand kit has a footer configured.
 */
export default function LegalLinks({ color = 'inherit', className = '' }) {
  return (
    <nav
      aria-label="Legal"
      className={`flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs ${className}`}
      data-testid="legal-links"
    >
      {FOOTER_LEGAL_LINKS.map((l) => (
        <a
          key={l.href}
          href={l.href}
          target="_blank"
          rel="noopener noreferrer"
          className="opacity-70 underline-offset-2 transition-opacity hover:underline hover:opacity-100"
          style={{ color }}
        >
          {l.label}
        </a>
      ))}
    </nav>
  );
}
